import Footer from "../Footer";
import Navbar from "../Navbar";
import CategoryBody from "../CategoryBody";

export default function CategoryPage(){
    return(
        <div>
            <Navbar />
            <CategoryBody />
            <Footer />

        </div>


    )


}